const Rails = require('@rails/ujs');

if (!window._rails_loaded) {
  Rails.start();
}

require('@rails/activestorage').start();
require('channels');

import '../stylesheets/application.scss';

const images = require.context('../images/', true);

import './main';
import './double_submit';

import './require_react';
